export default "__VITE_PUBLIC_ASSET__dad05dc0__"